import {
  InputAsyncSelect,
  InputMultiSelectControl,
  MultiSelect,
} from '../../Select'

function RentalPortalViewingApplicantsSelect({
  Control = InputMultiSelectControl,
  tagsProps,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      Select={InputAsyncSelect}
      tagsProps={{ ...tagsProps, onChange: onSelectItem, onClear }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default RentalPortalViewingApplicantsSelect
